import { cn } from "@/lib/utils";
import { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

interface DataTableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: string;
  className?: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>): JSX.Element {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  const currentSort: false | "asc" | "desc" = column.getIsSorted();

  return (
    <button
      type="button"
      onClick={() => column.toggleSorting(currentSort === "asc")}
      aria-label={`Ordenar por ${title}`}
      className={cn(
        "-ml-1 flex items-center gap-2 rounded px-1 py-1 font-medium text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#613F4F]",
        className
      )}
    >
      <span>{title}</span>
      {currentSort === "desc" ? (
        <ArrowDown className="h-3.5 w-3.5" />
      ) : currentSort === "asc" ? (
        <ArrowUp className="h-3.5 w-3.5" />
      ) : (
        <ChevronsUpDown className="h-3.5 w-3.5" />
      )}
    </button>
  );
}
